export enum ReportTemplateFormType {
  'create' = 'Create',
  'edit' = 'Edit',
  'duplicate' = 'Duplicate',
  'duplicateWithoutContinue' = 'DuplicateWithoutContinue'
}
